import { render, staticRenderFns } from "./configGroup.vue?vue&type=template&id=23f9b0b9&scoped=true"
import script from "./configGroup.vue?vue&type=script&lang=js"
export * from "./configGroup.vue?vue&type=script&lang=js"
import style0 from "./configGroup.vue?vue&type=style&index=0&id=23f9b0b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f9b0b9",
  null
  
)

export default component.exports